import { getText } from "../../config/api";

class BusinessService {
	static async getBalanceSheetCsv(restaurantId, { startDate, endDate }) {
		const url = `/v1/dashboard/restaurant/${restaurantId}/balance-sheet/csv`;
		return await getText({
			url,
			params: { startDate, endDate },
		});
	}
}

export default BusinessService;
